var map = {
	"./Companycultrue-create.png": "73a3",
	"./Companycultrue-culture.png": "9644",
	"./Companycultrue-dev.png": "799b",
	"./Companycultrue-live.png": "dd72",
	"./Companycultrue-mida.png": "7120",
	"./Companycultrue-midb.png": "a8f6",
	"./Companycultrue-people.png": "3681",
	"./Companycultrue-rc.png": "a8e7",
	"./Companycultrue-top.png": "887c",
	"./Grouphonor-mid.png": "7764",
	"./Grouphonor-top.png": "fb10",
	"./Prodoctfour-top.png": "28d9",
	"./Qualityserve-bac.png": "134d",
	"./Qualityserve-imga.png": "c2dc",
	"./Qualityserve-imgb.png": "e978",
	"./Qualityserve-imgc.png": "7d51",
	"./Qualityserve-mid.png": "0b93",
	"./Qualityserve-top.png": "5c05",
	"./Videopublicity-imgtest.png": "dbc9",
	"./Videopublicity-mid.png": "4a41",
	"./Videopublicity-play.png": "a22d",
	"./aboutcp.png": "6a6b",
	"./aboutus.png": "9712",
	"./aboutusbac.png": "b8cf",
	"./aboutustime.png": "6682",
	"./arrowcircle.png": "5dd2",
	"./arrowleft.png": "7810",
	"./arrowrig.png": "cdff",
	"./bluecircle.png": "6dab",
	"./circletime.png": "8913",
	"./classitem.png": "d4cd",
	"./gywm.png": "ec14",
	"./headercode.png": "0009",
	"./headernav.png": "c7d8",
	"./headertotop.png": "76d0",
	"./homenew.png": "33a8",
	"./indextheme.png": "bb31",
	"./jtry.png": "7f35",
	"./lcb.png": "6c82",
	"./ldgh.png": "2fb9",
	"./leadercare-care.png": "baae",
	"./leadercare-top.png": "6456",
	"./linkus-cd.png": "93d4",
	"./linkus-contact.png": "593a",
	"./linkus-cz.png": "0596",
	"./linkus-dy.png": "579d",
	"./linkus-nc.png": "bedb",
	"./linkus-shenz.png": "02b2",
	"./linkus-sw.png": "28c0",
	"./linkus-sz.png": "aac1",
	"./linkus-tg.png": "851a",
	"./linkus-top.png": "c3ad",
	"./linkus-wh.png": "2894",
	"./linkus-wms.png": "60f2",
	"./linkus-xg.png": "3bc8",
	"./milestone-mid.png": "3143",
	"./milestone-top.png": "61c0",
	"./navhome.png": "bc9e",
	"./navlogo.png": "129d",
	"./navlogoEn.png": "d020",
	"./newscenter-mid.png": "a561",
	"./newstop.png": "9497",
	"./prodoctsec-top.png": "e67f",
	"./productsec-arrow.png": "1a2c",
	"./productsec-mid.png": "a353",
	"./qywh.png": "7522",
	"./spxc.png": "8674"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";